module.exports = __webpack_public_path__ + "img/2.ac05dcf7.jpg";